module.exports = __webpack_public_path__ + "static/media/VidgoLogoWhiteV2.4f3bc05a.jpg";